import { Suspense } from "react";
import { Navigate } from "react-router";
import { Await, useLoaderData, useOutlet } from "react-router-dom";
import useUserStore from "@/stores/useUserStore";
import useAppStore from "@/stores/useAppStore";
import { getUserInfo } from "@/utils/loginUtils";
import ThemeSpinner from "@/components/ThemeSpinner";

export type AuthenticationResponse = {
  auth: boolean;
};

export const initAuthentication = async (request: Request) => {
  const { userInfo } = useUserStore.getState();

  const { token: history_token } = useAppStore.getState();

  const { searchParams } = new URL(request.url);

  const latest_token = searchParams.get("token");

  if (history_token && userInfo) {
    // 已经存在用户信息/token，但是url中的token与全局状态中的token不一致
    // 认为:用户更换了账号，但是客户端没有销毁webview,h5页面存在缓存
    if (latest_token && latest_token !== history_token) {
      const isOK = await getUserInfo(latest_token as string);
      return { auth: isOK };
    }
    return { auth: true };
  }

  const isOK = await getUserInfo(latest_token as string);

  return { auth: isOK };
};

const SecurityLayout = () => {
  const outlet = useOutlet();

  // react-router 类型有问题
  const { initAuthentication } = (useLoaderData() ?? {}) as {
    initAuthentication: AuthenticationResponse;
  };

  return (
    <Suspense fallback={<ThemeSpinner />}>
      <Await
        resolve={initAuthentication}
        children={(data: AuthenticationResponse) =>
          data?.auth ? outlet : <Navigate to="/error/403" replace />
        }
      />
    </Suspense>
  );
};
export default SecurityLayout;
